/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";

// Images
import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import DiscountIcon from '@mui/icons-material/Discount';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

export default function data() {

  const Description = ({ icon, title, description }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1} maxWidth={"100%"}>
      {icon}
       <MDBox display="block" ml={"1rem"}>
          <MDTypography display="block" variant="button" fontWeight="bold" color="text" ml={1} lineHeight={1.1}>
            {title}
          </MDTypography>
        {description.map((text, index) => (
          <MDTypography display="block" variant="button" fontWeight="regular" color="text" ml={1} lineHeight={1.1} key={description[0]+index}>
            {text}
          </MDTypography>
            
        ))}
        </MDBox>
    </MDBox>
  );

  return {
    columns: [
      { Header: "description", accessor: "description", width: "72%", align: "left" },
      { Header: "budget", accessor: "budget", width: "40%", align: "center" },
      { Header: "confidence", accessor: "completion",  width: "35%", align: "center" },
    ],

    rows: [ 
      {
        description: <Description icon={<QueryStatsIcon fontSize={"large"}/>} title={"Black friday is coming soon."}description={["More than 300 users registered this week. We suggest to create a new SHOP campaign to collect more data."]} />,
        budget: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            10,000 MOBITZ
          </MDTypography>
        ),
        completion: (
          <MDBox width="8rem" textAlign="left">
            <MDProgress value={85} color="dark" variant="gradient" label={true} />
          </MDBox>
        ),
      },
      {
        description: <Description icon={<DiscountIcon color="warning" fontSize={"large"}/>} title={"Prepare Discount campaign on TOBACCO SUBLIME EDP 100ML / 3.38 OZ."} description={["Generally, sales inceared on parfumes in all mall shops."]} />,
        budget: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            5,000 MOBITZ
          </MDTypography>
        ),
        completion: (
          <MDBox width="8rem" textAlign="left">
            <MDProgress value={90} color="warning" variant="gradient" label={true} />
          </MDBox>
        ),
      },
      {
        description: <Description icon={<ThumbUpAltIcon color="success" fontSize={"large"}/>} title={"People showed great score on FAUX SUEDE PUFFER JACKET. You can check results HERE."} description={["Prepare a discount campaign on level 3 avatars for this product"]} />,
        budget: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            15,000 MOBITZ
          </MDTypography>
        ),
        completion: (
          <MDBox width="8rem" textAlign="left">
            <MDProgress value={95} color="success" variant="gradient" label={true} />
          </MDBox>
        ),
      },
      {
        description: <Description icon={<AccessAlarmsIcon color="dark" fontSize={"large"}/>} title={"It's time to create a shop campaign in Riyadh!"} description={["100 avatars from Riyadh has joined Mobitoken in the last 3 days."]} />,
        budget: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            7,000 MOBITZ
          </MDTypography>
        ),
        completion: (
          <MDBox width="8rem" textAlign="left">
            <MDProgress value={75} color="dark" variant="gradient" label={true} />
          </MDBox>
        ),
      },
      {
        description: <Description icon={<ArrowCircleDownIcon color="error" fontSize={"large"}/>} title={"Lower your discount for LONG PUFFER JACKET."} description={["It seems like more than 80% of avatars couldn't get a discount for this product."]} />,
        budget: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            3,000 MOBITZ
          </MDTypography>
        ),
        completion: (
          <MDBox width="8rem" textAlign="left">
            <MDProgress value={60} color="error" variant="gradient" label={true} />
          </MDBox>
        ),
      },
    ],
  };
}
